var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.099,
    height: 42.255,
    viewBox: "0 0 41.099 42.255",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_96",
    "data-name": "Grupo 96",
    transform: "translate(-840.519 -1267)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_139",
    "data-name": "Caminho 139",
    d: "M10.272,20.226,17.261,16.2A2.017,2.017,0,0,0,18.32,14.3V6.248a2.016,2.016,0,0,0-1.059-1.906L10.272.318a2.1,2.1,0,0,0-2.224,0L1.059,4.342A2.224,2.224,0,0,0,0,6.248V14.3A2.224,2.224,0,0,0,1.059,16.2l6.989,4.024a2.1,2.1,0,0,0,2.224,0Z",
    transform: "translate(881.087 1278.967) rotate(90)",
    fill: "none",
    stroke: "#81d742",
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_140",
    "data-name": "Caminho 140",
    d: "M10.272,20.226,17.261,16.2A2.017,2.017,0,0,0,18.32,14.3V6.248a2.016,2.016,0,0,0-1.059-1.906L10.272.318a2.1,2.1,0,0,0-2.224,0L1.059,4.342A2.224,2.224,0,0,0,0,6.248V14.3A2.224,2.224,0,0,0,1.059,16.2l6.989,4.024a2.1,2.1,0,0,0,2.224,0Z",
    transform: "translate(861.593 1267.5) rotate(90)",
    fill: "none",
    stroke: "#81d742",
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_141",
    "data-name": "Caminho 141",
    d: "M10.272,20.226,17.261,16.2A2.017,2.017,0,0,0,18.32,14.3V6.248a2.016,2.016,0,0,0-1.059-1.906L10.272.318a2.1,2.1,0,0,0-2.224,0L1.059,4.342A2.224,2.224,0,0,0,0,6.248V14.3A2.224,2.224,0,0,0,1.059,16.2l6.989,4.024a2.1,2.1,0,0,0,2.224,0Z",
    transform: "translate(861.593 1290.434) rotate(90)",
    fill: "none",
    stroke: "#81d742",
    strokeWidth: 1,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElement);
export default __webpack_public_path__ + "static/media/Element.da0d7abd68c45ca9be6b845e4c1dc0f0.svg";
export { ForwardRef as ReactComponent };